export const GET_SLIDE_REQUEST = " GET_SLIDE_REQUEST";
export const GET_SLIDE_SUCCESS = " GET_SLIDE_SUCCESS";
export const GET_SLIDE_FAILURE = " GET_SLIDE_FAILURE";
